import { type ReactElement, useId } from 'react';
import { useIdentityAvailabilityQuery } from '@/entities/user';
import { WithdrawForm, WithdrawNoticeList } from '@/features/account-withdraw';

/** 회원 탈퇴(/my/withdraw) 본문 — 탈퇴로 달라지는 점을 먼저 안내하고, 확인 체크 뒤에 탈퇴한다. */
export const WithdrawPanel = (): ReactElement => {
  const headingId = useId();
  // 재가입 제한 안내는 서버가 본인인증을 쓴다고 확인됐을 때만 보인다(불러오는 중·실패면 숨김).
  const identityRequired = useIdentityAvailabilityQuery().data?.identityRequired === true;

  return (
    <section aria-labelledby={headingId} className="flex min-w-0 flex-col gap-8">
      <div className="flex flex-col gap-2">
        <h2
          id={headingId}
          className="text-2xl leading-tight font-bold tracking-[-0.02em] sm:text-[1.75rem]"
        >
          회원 탈퇴
        </h2>
        <p className="text-sm text-muted-foreground">
          탈퇴하기 전에 아래 내용을 꼭 확인해 주세요. 탈퇴는 되돌릴 수 없어요.
        </p>
      </div>
      <WithdrawNoticeList identityRequired={identityRequired} />
      <WithdrawForm />
    </section>
  );
};
